import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { Wallets } from 'types';

import { fixDecimal } from 'utils';

type WalletsListType = {
  wallets: Wallets;
};
const WalletsList: React.FC<WalletsListType> = ({
  wallets,
}: WalletsListType) => {
  return (
    <Box w="100%" borderTopWidth="1px" borderTopColor="rgba(255,255,255,0.08)">
      {wallets.map((wallet) => {
        const symbol = wallet.currency.symbol;
        const fractionDigits = wallet.currency.type === 'CRYPTO' ? 5 : 2;
        return (
          <HStack
            key={wallet.id}
            w="100%"
            align="center"
            gap={{ base: 3, md: 4 }}
            py={{ base: 4, md: 3 }}
            px={{ base: 0, md: 1 }}
            borderBottomWidth="1px"
            borderBottomColor="rgba(255,255,255,0.08)"
            transition="background 0.15s ease"
            _hover={{ bg: 'rgba(255, 255, 255, 0.04)' }}
          >
            <HStack flex="1" minW={0} align="center" gap={3}>
              <Box
                w="36px"
                h="36px"
                borderRadius="full"
                overflow="hidden"
                flexShrink={0}
              >
                <img
                  src={wallet.currency.icon}
                  alt={symbol}
                  width="36"
                  height="36"
                />
              </Box>
              <VStack align="flex-start" gap={0} minW={0}>
                <Text
                  fontSize="var(--chakra-font-sizes-sm)"
                  color="body"
                  fontWeight="medium"
                  lineHeight="short"
                >
                  {wallet.currency.title}
                </Text>
                <Text
                  fontSize="var(--chakra-font-sizes-sm)"
                  color="body2"
                  lineHeight="short"
                  textTransform="capitalize"
                >
                  {wallet.type === 'CRYPTO' ? 'Crypto' : 'Fiat'}
                </Text>
              </VStack>
            </HStack>
            <Text
              fontSize="var(--chakra-font-sizes-sm)"
              fontWeight="medium"
              color="body"
              fontVariantNumeric="tabular-nums"
              textAlign="end"
              flexShrink={0}
            >
              {`${fixDecimal({
                value: wallet.amount,
                fractionDigits,
              })} ${symbol}`}
            </Text>
          </HStack>
        );
      })}
    </Box>
  );
};
export default WalletsList;
